import { FormControl, FormLabel, Input, SimpleGrid } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface Props {
  groupName: string;
  leadRole: string;
  onGroupNameChange: (value: string) => void;
  onLeadRoleChange: (value: string) => void;
  showNameField: boolean;
  readOnly: boolean;
}

export const GroupDetailsFields = ({
  groupName,
  leadRole,
  onGroupNameChange,
  onLeadRoleChange,
  showNameField,
  readOnly,
}: Props) => {
  const { t } = useTranslation();

  return (
    <SimpleGrid columns={{ base: 1, md: showNameField ? 2 : 1 }} spacingX="8" spacingY="4" mb="5">
      {showNameField && (
        <FormControl>
          <FormLabel fontSize="sm">{t("Name of the group")}</FormLabel>
          <Input
            isReadOnly={readOnly}
            value={groupName}
            onChange={(e) => onGroupNameChange(e.target.value)}
          />
        </FormControl>
      )}
      <FormControl isRequired isInvalid={!readOnly && leadRole.trim().length === 0}>
        <FormLabel fontSize="sm">{t("Your own role in the group")}</FormLabel>
        <Input isReadOnly={readOnly} value={leadRole} onChange={(e) => onLeadRoleChange(e.target.value)} />
      </FormControl>
    </SimpleGrid>
  );
};
